export default __webpack_public_path__ + "static/media/students.8ee47a5b.svg";